import React from "react";
import FaceMeshHairstylePage from "./FaceMeshHairstyle";

const FaceMeshHairstyleScratchPage = () => {
  return <FaceMeshHairstylePage continueUrl="/scratch-hairstyle" missingImageHelpPath="/facemesh-hairstyle-scratch" />;
};

export default FaceMeshHairstyleScratchPage;
